import styled from 'styled-components';
import { Badge } from '@arcadiapower/shrike';

export const StyledStatusPill = styled(Badge)<{
  status?: string;
}>`
  width: fit-content;
`;
